import { useEffect, useState } from "react";
import { isDisplayableUrl } from "../utils/imageUrl";

/**
 * Renders an organisation / issuer logo image if a valid URL is provided.
 * If the URL is missing, invalid, a raw storage key, or fails to load (e.g. expired signed URL),
 * it gracefully displays the fallback text/initials without breaking layout or showing a broken image.
 */
export function SafeLogo({
  src,
  alt = "Logo",
  fallbackText = "ORG",
  className,
  style,
  imgClassName,
  imgStyle,
  fallbackClassName,
  fallbackStyle,
}) {
  const [loadFailed, setLoadFailed] = useState(false);

  useEffect(() => {
    setLoadFailed(false);
  }, [src]);

  const displayable = !loadFailed && isDisplayableUrl(src);

  if (displayable) {
    return (
      <img
        src={src}
        alt={alt}
        onError={() => setLoadFailed(true)}
        className={imgClassName ?? className}
        style={imgStyle ?? style}
      />
    );
  }

  return (
    <div
      className={fallbackClassName ?? className}
      style={fallbackStyle ?? style}
    >
      {fallbackText}
    </div>
  );
}
